/* global google */

import $ from "jquery";
import { isMobile, browser } from "./responsive";
import { wobble } from "./util";
import { roundware, ROUNDWARE_INITIAL_LATITUDE, ROUNDWARE_INITIAL_LONGITUDE, ROUNDWARE_SERVER_BASE_URL } from "./roundware";
import markerImgUrl from "../../images/map-markerB.png"
import { CoronaDiariesMapStyle } from "./map-style";

console.log(browser);
if (isMobile) {
  console.log("Mobile/tablet device detected");
  $("#menu-listen").hide();
} else {
  console.log("Desktop device detected");
  $("#menu-mobile").hide();
}

// Retrieve asset/envelope params from url querystring
var getParams = function (url) {
	var params = {};
	var parser = document.createElement('a');
	parser.href = url;
	var query = parser.search.substring(1);
	var vars = query.split('&');
	for (var i = 0; i < vars.length; i++) {
		var pair = vars[i].split('=');
		params[pair[0]] = decodeURIComponent(pair[1]);
	}
	return params;
};

let urlParams = getParams(window.location.href);
let eid = urlParams.eid;
console.log(eid);

const roundwareConnectionPromise = new Promise((resolve, reject) => {
  roundware.
    connect().
    then(connectParams => resolve(connectParams)).
    catch(err => {
      console.error('Roundware unable to connect', err);
      reject('We were unable to connect to Roundware due to error, please try again.');
    });
});


// This function is intended to be invoked by the google API callback; see index.html
/* eslint-disable-next-line no-unused-vars */
async function initDemo() {
  console.log("calling init demo");
  const googleMapsCenter = {
    lat: 25.0,
    lng: 20.0
  };

  const listenMapEl = document.getElementById('mapBlock');

  var styledMapType = new google.maps.StyledMapType(
    CoronaDiariesMapStyle,
    { name: 'Future Style' }
  );

  const map = new google.maps.Map(listenMapEl, {
    zoom: 3,
    maxZoom: 18,
    gestureHandling: 'none',
    zoomControl: false,
    center: googleMapsCenter,
    mapTypeControl: false,
    draggableCursor: 'cursor',
    streetViewControl: false,
    fullscreenControl: false,
    rotateControl: false,
    mapTypeId: google.maps.MapTypeId.ROAD, // HYBRID
    mapTypeControlOptions: {
      mapTypeIds: ['satellite', 'hybrid', 'styled_map'],
      style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
      position: google.maps.ControlPosition.BOTTOM_LEFT
    },
  });
  map.mapTypes.set('styled_map', styledMapType);
  map.setMapTypeId('styled_map');

  try {
    const { uiConfig } = await roundwareConnectionPromise;

    const assets = await roundware.getAssets({envelope_id: eid});
    console.log(assets);
    const asset = await roundware.getAsset(assets[0].id);
    console.log(asset);
    let markerImage = {
      url: markerImgUrl,
      // This marker is 50 pixels wide by 50 pixels high.
      scaledSize: new google.maps.Size(30, 30),
      // The origin for this image is (0, 0).
      origin: new google.maps.Point(0, 0),
      // The anchor for this image is the base of the point.
      anchor: new google.maps.Point(0, 15)
    };

    const point = new google.maps.LatLng(wobble(assets[0].latitude, .01), wobble(assets[0].longitude, .01));

    const marker = new google.maps.Marker({
      map,
      position: point,
      icon: markerImage,
      cursor: 'cursor'
    });
    map.setCenter(point);
    map.setZoom(13);

    console.log('start geocoding');
    const reverseGeocodingResult = await geocodeLatLng(new google.maps.Geocoder, point);
    console.log(reverseGeocodingResult);
    console.log(assets);
    let tagHtml = '<h2>' + reverseGeocodingResult.city + ', ' + reverseGeocodingResult.country + ', ' +new Date(assets[0].created).toDateString() + '</h2>';
    tagHtml += assets[0].tag_ids.map(t => {
      // for now, do not display any partner tags
      // once framework has findTagCategory(tag_id), that will provide more robust solution
      // const partnerTagIds = [329,330,331,332,333,334,335];
      // if (!partnerTagIds.includes(t)) {
      //   return '<h3 class="sharingTagText">' + roundware.findTagDescription(t) + "</h3>"
      // }
    }).join("");
    $('#tagBlock').append(tagHtml);
    $('#tagBlock').show();

    const assetUrlMp3 = ROUNDWARE_SERVER_BASE_URL + 'rwmedia/' + assets[0].filename.replace("wav","mp3");
    const assetUrlWav = ROUNDWARE_SERVER_BASE_URL + 'rwmedia/' + assets[0].filename;


    console.log(assetUrlMp3);
    $('#soundBlock').append('<audio controls="controls" preload="auto" controlslist="nodownload"><source src="' + assetUrlMp3 + '" type="audio/mpeg" />' +
                            '<source src="'+ assetUrlWav + '" type="audio/wav" />' +
                            '</audio>');
    $('#soundBlock').append('<a class="download"><span id="download' + asset.id + '" class="icon solid fa-download infoDownload" alt="download this audio file"></span></a>');
    $('#soundBlock').show();

    $(`#download${asset.id}`).click(function() {
      fetch(`${assetUrlMp3}`, {
        headers: new Headers({
          'Origin': location.origin
        }),
        mode: 'cors'
      })
        .then(response => response.blob())
        .then(blob => {
          let blobUrl = window.URL.createObjectURL(blob);
          var a = document.createElement('a');
          a.download = `future_inclusion_${asset.id}`;
          a.href = blobUrl;
          // For Firefox https://stackoverflow.com/a/32226068
          document.body.appendChild(a);
          a.click();
          a.remove();
        })
        .catch(e => console.error(e));
    });

    updateTwitterShareButton(reverseGeocodingResult);
    updateFacebookShareButton(reverseGeocodingResult);
    updateWhatsappShareButton(reverseGeocodingResult);


    $('#contributeButton').click(function() {
      window.location.href = './index.html';
    });

  } catch (err) {
    const errBox = document.getElementById('errorDisplay');
    errBox.style.display = 'block';
    errBox.appendChild(document.createTextNode(err));
    console.error(err);
  }
}

const googleMapsApiKey = "AIzaSyCmYUeVE8rq7no5-uWa1Js1JCY154WM8Is"; // in development mode, set the file '.env' for this value
const scriptTag = document.createElement('script');
window.initDemo = initDemo; // so google maps API can see the callback, below

let src = 'https://maps.googleapis.com/maps/api/js?callback=initDemo&language=en';

if (googleMapsApiKey !== '') {
  src = src + '&key=' + googleMapsApiKey;
}

function geocodeLatLng(geocoder, input) {
  return new Promise(function(resolve, reject) {
    geocoder.geocode({ location: input, region: 'es'
    }, function(results, status) {
      if (status === 'OK') {
        console.log(transformgeocodingResults(results, 'locality'))
        resolve({
          city: transformgeocodingResults(results, 'locality').long_name,
          country: transformgeocodingResults(results, 'country').long_name
        });
      } else {
        reject(status);
      }
    });
  });
}

function updateTwitterShareButton(geocodingResult) {
  $('#twitterShareBlock').empty();
  $('#twitterShareBlock').append('<a style="display: none" id="twitterShareBtn" href="https://twitter.com/share" class="twitter-share-button" data-size="large" data-text="Listen to this #FutureInclusion recording from #' + geocodingResult.city + ', #' + geocodingResult.country + ' -  Check out #ArtsIncubator project @FutureInclusionlab supported by @ArsElectronica @ZERO1_ART @ECAatState @usembvienna #arselectronica20 #socialinclusion" data-hashtags="" data-show-count="false">Tweet</a>')
  $.getScript("https://platform.twitter.com/widgets.js");
  //$('#twitterShareBlock a').show();

}

function updateFacebookShareButton(geocodingResult) {
  $('meta[property="og:description"]').attr('content', 'test');
  (function(d, s, id) {
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) return;
    js = d.createElement(s); js.id = id;
    js.src = "https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.0";
    fjs.parentNode.insertBefore(js, fjs);
  }(document, 'script', 'facebook-jssdk'));
}

function updateWhatsappShareButton(geocodingResult) {
  if (isMobile) {
    $('#whatsapp-share-button a').attr('href', encodeURI('whatsapp://send?text=Listen to this #FutureInclusion recording from ' + geocodingResult.city + ', ' + geocodingResult.country + ' ' + window.location.href))
    $('#whatsapp-share-button').show();
  }
}

function transformgeocodingResults(result, type) {
  const results = []
  result.map(r => r.address_components.map(address => {
    if (address.types.indexOf(type) > -1) { results.push(address) }
  }));
  return results.length > 0 ? results[0] : {};
}

scriptTag.src = src;

document.body.appendChild(scriptTag);
